import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isPreBookedPayment, isSameCurrency } from '../states/rates/selectors';
import { connect } from 'react-redux';

const mapState = (state) => ({
	isPreBookedPayment: isPreBookedPayment(state),
	isSameCurrency: isSameCurrency(state),
});

export default (WrappedComponent) => {
	const withFxRatesCounter = class extends Component {
		constructor(props) {
			super(props);

			this.state = {
				showInitialGetRate: null,
				showRefresh: false,
				counter: props.ratesCounterLimit,
			};
			this.initialiseCounter = this.initialiseCounter.bind(this);
		}

		componentWillMount() {
			const { isPreBookedPayment } = this.props;
			this.setState({ showInitialGetRate: !isPreBookedPayment });
		}

		componentWillUnmount() {
			clearInterval(this.intervalHandler);
		}

		initialiseCounter(fxValidityDuration) {
			this.setState((state, props) => ({
				showInitialGetRate: false,
				showRefresh: false,
				counter: fxValidityDuration || props.ratesCounterLimit,
			}));
			this.intervalHandler = setInterval(() => {
				this.setState(
					(previousState) => ({
						counter: previousState.counter - 1,
					}),
					() => {
						if (this.state.counter === 0) {
							clearInterval(this.intervalHandler);
							this.setState({
								showRefresh: true,
							});
						}
					}
				);
			}, 1000);
		}

		render() {
			const { counter, showInitialGetRate, showRefresh } = this.state;
			return (
				<WrappedComponent
					{...this.props}
					initialiseCounter={this.initialiseCounter}
					counter={counter}
					showInitialGetRate={showInitialGetRate}
					showRefresh={showRefresh}
				/>
			);
		}
	};

	withFxRatesCounter.displayName = `withFxRatesCounter(${
		WrappedComponent.displayName || WrappedComponent.name || 'Component'
	})`;

	withFxRatesCounter.propTypes = {
		ratesCounterLimit: PropTypes.number,
	};

	return connect(mapState)(withFxRatesCounter);
};
